const config = require('../../config');
let url = {
    apiUrl: '/admin',
    // apiUrl: process.env.apiUrl,
    //staticPath:config.dev.staticPath,       //开发环境静态资源路径
    staticPath: process.env.NODE_ENV !== 'development' ?  config.build.staticPath: config.dev.staticPath
};
window.between=function () {
      var docEl = document.documentElement;
      var clientWidth = docEl.clientWidth;
      return 20 * (clientWidth / 375);

}
export const api = {
    "in_showing":url.staticPath+"/dataJson/in_theaters.json",
    "in_coming":url.staticPath+"/dataJson/in_comings.json",
    "getMuseumSearchList":url.apiUrl+"/m/Guide/getMuseumSearchList.do",   //博物馆列表

   "getAreaList":url.apiUrl+"/m/Guide/getAreaList.do",            //博物馆区域


   "getCollectionSearch":url.apiUrl+"/m/collection/getCollectionSearch.do",
   "getCollectionById":url.apiUrl+"/m/collection/getCollectionById.do",//藏品详情
   "getCollectionList":url.apiUrl+"/m/collection/getCollectionList.do",//藏品列表
   "getArticleListByUniqueType":url.apiUrl+"/m/article/getArticleListByUniqueType.do",//资讯列表
   "getArticleById":url.apiUrl+"/m/article/getArticleById.do",//资讯列表详情
   "mumDetail":url.apiUrl+"/m/Guide/getMuseumDetail.do",   //博物馆详情

    "indexSpreadtrum":url.apiUrl+"/m/index/info.do",//首页列表
    "activity":url.apiUrl+"/m/activity/getActivityListByType.do",//活动列表
    "studyDetail":url.apiUrl+"/m/activity/getActivityById.do",//活动详情
    "zhanlan":url.apiUrl+"/m/spreadtrum/getSpreadtrumList.do",//展览列表
    "zhanlanDetail":url.apiUrl+"/m/spreadtrum/getSpreadtrumById.do",//展览详情
    "arealist":url.apiUrl+"/m/spreadtrum/getAreaList.do",//地区详情

    "userInfo":url.apiUrl+"/m/myInfo/userInfo.do",//查询个人信息详情
    "saveInfo":url.apiUrl+"/m/myInfo/saveInfo.do",//保存个人信息

    "checkPassword":url.apiUrl+"/m/checkPassword.do",//校验原密码
    "modifyPassword":url.apiUrl+"/m/modifyPassword.do",//修改密码
    "guidedetail":url.apiUrl+"/m/Guide/getGuideDetail.do",
    "themelist":url.apiUrl+"/m/Guide/getPictureList.do",
    "themedetail":url.apiUrl+"/m/Guide/getCollectInfoList.do",

    "myCollects":url.apiUrl+"/m/myInfo/myCollects.do",//查询用户收藏列表
    "delCollect":url.apiUrl+"/m/myInfo/delCollect.do",//取消收藏和删除收藏
    "addCollect":url.apiUrl+"/m/myInfo/addCollect.do",//取消收藏和删除收藏

  "loginOut":url.apiUrl+"/m/loginOut.do",//退出登录
  "uploadHeadImage":url.apiUrl+"/m/uploadHeadImage.do",//上传图片
  "login":url.apiUrl+"/mobileLogin.do",//登录
  "code":url.apiUrl+"/m/sendSecretCode.do",//验证码
  "checkCode":url.apiUrl+"/m/check.do",   //校验验证码
  "register":url.apiUrl+"/m/register.do",//注册
  // "password":url.apiUrl+"/m/resetPassword.do",//忘记密码
  "password":url.apiUrl+"/front/resetPass.do",//忘记密码
  "weixin":url.apiUrl+"/m/wxLogin.do",
  /*"qq":url.apiUrl+"/qq.do"*/
  "qq":"http://test.tj720.com/admin/qq.do",
  "getForumData" : "http://bjmuseum.org.cn/activity/research.json"
}



// WEBPACK FOOTER //
// ./src/global/api.js